import angular from 'angular';
import vcRecaptcha from 'angular-recaptcha';

import messagingService from './../messaging/messaging.module';
import favouriteService from './../favourites/service/favourites-service.module';
import realEstateHandler from './../real-estate/real-estate-handler.module';
import { CompareComponent } from './compare.component';

const MODULE_NAME = 'compare';

export default angular.module(MODULE_NAME, [messagingService, vcRecaptcha, favouriteService, realEstateHandler]).component('compareComponent', CompareComponent)
	.name;
